/** @jsxImportSource @emotion/react */
import { colors, HeadingH3, Text } from 'components/landing/ui';

import { modList } from '../../../settings';

const Info = ({ currentModuleId, ...rest }) => (
  <div
    css={{
      flexDirection: 'column',
      width: '100%',
      h3: { marginBottom: 20 },
      'section &': {
        alignItems: 'center',
        '@media (min-width:992px)': { alignItems: 'flex-start', marginBottom: 0 },
      },
    }}
    {...rest}
  >
    <HeadingH3>{modList[currentModuleId].title}</HeadingH3>
    <Text css={{ color: colors.grayLight }}>{modList[currentModuleId].description}</Text>
  </div>
);

export default Info;
